var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PropTypes, Component } from 'react';
import styleColor from './colors';

var defaultProps = {
  url: 'X',
  size: 50,
  radius: 0
};

var LetterAvatar = function (_React$Component) {
  _inherits(LetterAvatar, _React$Component);

  function LetterAvatar() {
    _classCallCheck(this, LetterAvatar);

    return _possibleConstructorReturn(this, (LetterAvatar.__proto__ || Object.getPrototypeOf(LetterAvatar)).apply(this, arguments));
  }

  _createClass(LetterAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          size = _props.size,
          radius = _props.radius;


      var char = url.toUpperCase();

      var bgColor = [255, 100, 124];

      if (/[A-Z]/.test(char)) {
        var index = char.charCodeAt() - 65;
        bgColor = styleColor[index];
      } else if (/[\d]/.test(char)) {
        bgColor = styleColor[parseInt(char)];
      } else {
        bgColor = [0, 0, 0];
      }

      if (!Array.isArray(bgColor)) {
        bgColor = [1, 132, 187];
      }

      var style = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgb(' + bgColor + ')',
        width: size,
        height: size,
        fontSize: Math.floor(size / 2.5) + 'px',
        lineHeight: size + Math.floor(size / 12) + 'px',
        borderRadius: radius,
        color: '#fff',
        fontFamily: 'polifont, sans-serif'
      };
      if (url != null && url.substring(0, 8) == 'https://' || url.substring(0, 8) == 'data:ima') {
        return React.createElement('img', { style: style, src: url });
      } else {
        return React.createElement(
          'div',
          { style: style },
          char
        );
      }
    }
  }]);

  return LetterAvatar;
}(React.Component);

;

export default LetterAvatar;